/**
 * @generated SignedSource<<634d8ca034d2498a989d5a4ffee872da>>
 * @relayHash 70e80297d041fb31c0639d661a01c799
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useGetCurrentStorageUsageQuery$variables = Record<PropertyKey, never>;
export type useGetCurrentStorageUsageQuery$data = {
  readonly storage: {
    readonly bytesUsed: AGG$Long;
    readonly gracePeriodEndDate: string | null | undefined;
    readonly isStorageEnforcementGracePeriodComplete: boolean | null | undefined;
  } | null | undefined;
};
export type useGetCurrentStorageUsageQuery = {
  response: useGetCurrentStorageUsageQuery$data;
  variables: useGetCurrentStorageUsageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": "storage",
    "concreteType": "ConfluenceStorage",
    "kind": "LinkedField",
    "name": "confluence_storage",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "bytesUsed"
      },
      {
        "kind": "ScalarField",
        "name": "isStorageEnforcementGracePeriodComplete"
      },
      {
        "kind": "ScalarField",
        "name": "gracePeriodEndDate"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useGetCurrentStorageUsageQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useGetCurrentStorageUsageQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "70e80297d041fb31c0639d661a01c799",
    "id": "6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54",
    "metadata": {},
    "name": "useGetCurrentStorageUsageQuery",
    "operationKind": "query",
    "text": "query useGetCurrentStorageUsageQuery{storage:confluence_storage{bytesUsed,isStorageEnforcementGracePeriodComplete,gracePeriodEndDate}}"
  }
};
})();

(node as any).hash = "41d2bf41d832c3866355b26b49942948";

export default node;
